// extracted by mini-css-extract-plugin
export var centerText = "_4k-8";
export var container = "_4k-0";
export var doughnutContainer = "_4k-7";
export var legend = "_4k-a";
export var legendItemColorDisplay = "_4k-b";
export var legendItemLabel = "_4k-d";
export var legendItemValue = "_4k-c";
export var lg = "_4k-5";
export var maxWidth = "_4k-9";
export var md = "_4k-4";
export var responsive = "_4k-6";
export var sm = "_4k-3";
export var xs = "_4k-2";
export var xxs = "_4k-1";